<template>
  <aside
    class="scrollView position-fixed left-sidebar;"
    style="background-color: rgb(255, 255, 255); height: 100vh"
  >
    <div
      style="
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
      "
    >
      <div
        style="
          display: flex;
          justify-content: center;
          background-color: #fff;
          max-height: 100px;
        "
      >
        <img
          style="width: 205px"
          :src="'data:image/png;base64,' + logo"
          alt=""
        />
      </div>
      <div style="display: flex; justify-content: center">
        <i
          v-if="!authUser.userable.profile_picture"
          style="
            color: rgb(140, 198, 63);
            padding: 15px;
            font-size: 75px;
            margin-top: 10px;
          "
          class="fa fa-user-circle"
        ></i>
        <div v-else style="border-radius: 50%; width: 75px; height: 75px">
          <img
            :src="
              'data:image/' +
              authUser.userable.profile_picture.extension +
              ';base64,' +
              authUser.userable.profile_picture.image
            "
            style="height: 100%; width: 100%; border-radius: 50%"
            alt=""
          />
        </div>
      </div>
      <p style="text-align: center; font-size: 14px; margin: 5px">
        {{ authUser.userable.title }} {{ authUser.userable.first_name }}
        {{ authUser.userable.last_name }}
      </p>
      <div style="display: flex; justify-content: center">
        <i
          style="font-size: 12px; cursor: pointer"
          class="fa fa-user"
          @click="redirectToProfile()"
        ></i>
        <i
          style="font-size: 12px; cursor: pointer; margin-left: 15px"
          class="fa fa-power-off"
          @click="signOut()"
        ></i>
      </div>
      <ul
        class="no-bullets"
        style="
          margin-top: 35px;
          font-size: 13px;
          width: 100%;
          padding-left: 20px;
        "
      >
        <li style="margin-top: 5px" v-for="(link, i) in links" :key="i">
          <router-link
            style="min-width: 100%; display: block"
            @click.native="link.url ? '' : toggleSubItems(link)"
            :to="link.url ? '/' + authUser.userable_type + '/' + link.url : ''"
          >
            <i
              style="color: #3c4858; width: 8%"
              :class="['fa', 'fa-' + link.icon]"
            ></i>
            <span style="color: #3c4858; width: 75%; display: inline-block">
              {{ link.text }}
            </span>
            <i
              style="color: #3c4858; width: 8%; text-align: center"
              v-if="link.subLinks"
              :class="
                subItemsVisible(link)
                  ? 'fa fa-chevron-up'
                  : 'fa fa-chevron-down'
              "
            ></i>
          </router-link>
          <ul
            style="padding-left: 20px"
            :class="subItemsVisible(link) ? 'collapse show in' : 'collapse'"
            class="no-bullets"
            v-if="link.subLinks"
          >
            <li :key="l" v-for="(subLink, l) in link.subLinks">
              <router-link
                :to="
                  subLink.url
                    ? '/' + authUser.userable_type + '/' + subLink.url
                    : '#'
                "
              >
                <i
                  style="font-size: 15px; color: #1976d2"
                  :class="['mdi', 'mdi-' + subLink.icon]"
                ></i>
                <span style="color: #3c4858">
                  {{ subLink.text }}
                </span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { mapState } from "vuex";
import StorageMediaFileFilter from "../filters/StorageMediaFileFilter";
import { getStorageMediaFile } from "../api/directapi";
import sweetAlert from "sweetalert2";

export default {
  data() {
    return {
      toggleInvestorsManagement: false,
      togglePortfolioManagement: false,
      logo: null,
    };
  },
  created: function () {
    let storageMediaFileFilter = StorageMediaFileFilter();
    storageMediaFileFilter.names = ["YurBe_Logos_Logo_Small_Full_Color.png"];
    getStorageMediaFile(storageMediaFileFilter).then((response) => {
      this.logo =
        response.body.results.images.YurBe_Logos_Logo_Small_Full_Color;
    });
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
    }),
    links() {
      return [
        {
          url: "dashboard",
          icon: "tachometer-alt",
          text: "Dashboard",
        },
        {
          icon: "tasks",
          text: "Portfolio Management",
          subLinks: [
            {
              url: "projects",
              icon: "",
              text: "Projects",
            },
            {
              url: "clusters",
              icon: "",
              text: "Clusters",
            },
            {
              url: "assets",
              icon: "",
              text: "Assets",
            },
            // {
            //   url: "components",
            //   icon: "",
            //   text: "Components",
            // },
            {
              url: "plans",
              icon: "",
              text: "Plans",
            },
            // {
            //   url: "projects/contracts",
            //   icon: "",
            //   text: "Contracts",
            // },
            {
              url: "projects/accounts",
              icon: "",
              text: "Accounts",
            },
            {
              url: "projects/transactions",
              icon: "",
              text: "Transactions",
            },
            {
              url: "projects/valuations",
              icon: "",
              text: "Valuations",
            },
          ],
        },
        {
          icon: "handshake",
          text: "Investors Management",
          subLinks: [
            {
              url: "investors",
              icon: "",
              text: "Investors",
            },
            {
              url: "investors/contracts",
              icon: "",
              text: "Contracts",
            },
            {
              url: "investors/accounts",
              icon: "",
              text: "Accounts",
            },
            {
              url: "investors/transactions",
              icon: "",
              text: "Transactions",
            },
            {
              url: "investors/transaction-requests",
              icon: "",
              text: "Transaction Requests",
            },
          ],
        },
        {
          url: "news",
          icon: "newspaper",
          text: "News & Updates",
        },
        // {
        //   url: "activities",
        //   icon: "bell",
        //   text: "Tasks & Notifications",
        // },
        // {
        //   url: "library",
        //   icon: "images",
        //   text: "Library",
        // },
      ];
    },
  },
  components: {},
  methods: {
    toggleSubItems(link) {
      if (link.text == "Portfolio Management") {
        this.togglePortfolioManagement = !this.togglePortfolioManagement;
      } else if (link.text == "Investors Management") {
        this.toggleInvestorsManagement = !this.toggleInvestorsManagement;
      }
    },
    subItemsVisible(link) {
      if (link.text == "Portfolio Management") {
        return this.togglePortfolioManagement;
      } else if (link.text == "Investors Management") {
        return this.toggleInvestorsManagement;
      }
      return false;
    },
    signOut() {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to sign out?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("logoutUser");
        }
      });
    },
    redirectToProfile() {
      this.$router.push("/" + this.authUser.userable_type + "/profile");
    },
  },
};
</script>

<style lang="scss">
ul.no-bullets {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.scrollView::-webkit-scrollbar {
  display: none;
  overflow: scroll;
}
.scrollView {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Sidebar.vue